import { connectHook } from 'app/common/components/connect-hook';
import { ProjectUsers } from './project-users';
import { useProjectUsers } from './project-users-hook';

export default connectHook(ProjectUsers, useProjectUsers);
